export default __webpack_public_path__ + "static/media/bg.b090ae86.webp";